// Put your application javascript here
$(document).ready(function() {

   var $map = $(".map");
   var bounds = new google.maps.LatLngBounds();

   // Initialise les options de la carte
   var options = {
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      disableDefaultUI: true,
      zoom: 5,
      minZoom: 2,
      maxZoom: 16,
      draggable: true,
      zoomControl: true,
      draggableCursor: 'pointer',
      gestureHandling: 'cooperative',
      center: new google.maps.LatLng(48.884399920436216, 2.345449000881243),
      styles: [{"featureType":"administrative","elementType":"all","stylers":[{"saturation":"-100"}]},{"featureType":"administrative.province","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"landscape","elementType":"all","stylers":[{"saturation":-100},{"lightness":65},{"visibility":"on"}]},{"featureType":"poi","elementType":"all","stylers":[{"saturation":-100},{"lightness":"50"},{"visibility":"simplified"}]},{"featureType":"poi.business","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":"-100"}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"visibility":"on"}]},{"featureType":"road.highway","elementType":"labels.text","stylers":[{"visibility":"off"}]},{"featureType":"road.highway","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"road.arterial","elementType":"all","stylers":[{"lightness":"30"}]},{"featureType":"road.local","elementType":"all","stylers":[{"lightness":"40"}]},{"featureType":"transit","elementType":"all","stylers":[{"saturation":-100},{"visibility":"simplified"}]},{"featureType":"water","elementType":"geometry","stylers":[{"hue":"#ffff00"},{"lightness":-25},{"saturation":-97}]},{"featureType":"water","elementType":"labels","stylers":[{"lightness":-25},{"saturation":-100}]}]
   };

   // Ajoute les options de la carte
   map = new google.maps.Map($map.get(0), options);

   markers = [];
   var nfos = [];

   // On prépare l'icone des markers
   var image = {
      url: $map.data("ic"),
      size: new google.maps.Size(14, 20),
      scaledSize: new google.maps.Size(14, 20),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(9, 20)
   };

   map_detail.forEach(function(v) {
      var marker = new google.maps.Marker({
         map: map,
         icon: image,
         position: new google.maps.LatLng(v.latitude, v.longitude),
         title: v.name,
         marker_id: v.id
      });

      markers.push(marker);
      bounds.extend(marker.getPosition());

      var nfo = new google.maps.InfoWindow({
         content: '<p class="pin"><strong>' + v.name + '</strong><br />' + v.address + '<br />' + v.cp + ' - ' + v.city + '<br />' + v.phone + '</p><div class="hours">' + v.hours + '</div>'
      });

      nfos.push(nfo);

      marker.addListener("click", function() {
         $.each(nfos, function(k, v) {
            v.close();
         });
         nfo.open(map, marker);
      });
   });

   // On ajoute les marqueurs
   for (var i = 0; i < markers.length; i++) {
      markers[i].setVisible(true);
   }

   // Ajoute un "padding" de 200 pixels dans la carte
   map.fitBounds(bounds, '200');

   // Outil de recherche
   $('#store_search').submit(function(e){
      e.preventDefault();
      var query = $('#stores_input').val();
      var geocoder = new google.maps.Geocoder();
      geocoder.geocode(
         {'address': query},
         function(results, status) {
            if(status == google.maps.GeocoderStatus.OK){
               var first_result = results[0];
               map.fitBounds(first_result.geometry.bounds, '200');
            }
            else console.log("location not found");
         }
      );
   });
});
